//Legacy Views
// @deprecated use new view types
export const DAY_VIEW = 'day';
// @deprecated use new view types
export const WEEK_VIEW = 'week';
// @deprecated use new view types
export const MONTH_VIEW = 'month';

//View Types
export const MYSCHEDULE_VIEW = 'myschedule';
export const POSITION_VIEW = 'position';
export const COVERAGE_VIEW = 'coverage';
export const EMPLOYEE_VIEW = 'employee';
export const JOB_SITE_VIEW = 'jobsite';

//Date Ranges
export const TWO_WEEK_RANGE = 'two-week';
export const WEEK_RANGE = 'week';
export const DAY_RANGE = 'day';
export const MONTH_RANGE = 'month';

export type ViewType =
  | typeof DAY_VIEW
  | typeof WEEK_VIEW
  | typeof MONTH_VIEW
  | typeof POSITION_VIEW
  | typeof MYSCHEDULE_VIEW
  | typeof COVERAGE_VIEW
  | typeof EMPLOYEE_VIEW
  | typeof JOB_SITE_VIEW;

export type ViewRange = typeof DAY_RANGE | typeof WEEK_RANGE | typeof TWO_WEEK_RANGE | typeof MONTH_RANGE;

export const RangeLabels: { [key in ViewRange]: string } = {
  [DAY_RANGE]: 'Day',
  [WEEK_RANGE]: 'Week',
  [TWO_WEEK_RANGE]: 'Two Weeks',
  [MONTH_RANGE]: 'Month',
};

export const ViewLabels: { [key in ViewType]: string } = {
  [EMPLOYEE_VIEW]: 'Users',
  [POSITION_VIEW]: 'Positions',
  [JOB_SITE_VIEW]: 'Job Sites',
  [COVERAGE_VIEW]: 'Coverage',
  [DAY_VIEW]: 'Day',
  [WEEK_VIEW]: 'Week',
  [MONTH_VIEW]: 'Month',
  [MYSCHEDULE_VIEW]: 'My Schedule',
};
